module.exports = __webpack_public_path__ + "static/media/mob-conan-main.3f176065.jpg";